module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "me"
  }, [_c('div', {
    staticClass: "user"
  }, [_c('div', {
    staticClass: "user-flex"
  }, [_c('div', {
    staticClass: "user-img"
  }, [_c('img', {
    attrs: {
      "src": _vm.img,
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "user-gutter"
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _c('group', [_c('cell', {
    attrs: {
      "is-link": "",
      "link": "https://github.com/Vue-Alex"
    }
  }, [_c('i', {
    staticClass: "fa fa-github-square fs24",
    attrs: {
      "aria-hidden": "true"
    },
    slot: "icon"
  }), _vm._v(" "), _c('span', [_vm._v("GitHub")]), _vm._v(" "), _c('span', {
    staticClass: "ml20 colorC",
    slot: "after-title"
  }, [_vm._v("Vue-Alex")])]), _vm._v(" "), _c('cell', {
    attrs: {
      "is-link": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-code fs24",
    attrs: {
      "aria-hidden": "true"
    },
    slot: "icon"
  }), _vm._v(" "), _c('span', [_vm._v("Code")]), _vm._v(" "), _c('span', {
    staticClass: "ml20 colorC",
    slot: "after-title"
  }, [_vm._v("See my code")])])], 1), _vm._v(" "), _c('group', [_c('cell', {
    attrs: {
      "is-link": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-picture-o fs24",
    attrs: {
      "aria-hidden": "true"
    },
    slot: "icon"
  }), _vm._v(" "), _c('span', [_vm._v("Photos")]), _vm._v(" "), _c('span', {
    staticClass: "ml20 colorC",
    slot: "after-title"
  }, [_vm._v("See my photos")])])], 1), _vm._v(" "), _c('group', [_c('cell', {
    attrs: {
      "is-link": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-volume-control-phone",
    attrs: {
      "aria-hidden": "true"
    },
    slot: "icon"
  }), _vm._v(" "), _c('span', [_vm._v("Callme")]), _vm._v(" "), _c('span', {
    staticClass: "ml20 colorC",
    slot: "after-title"
  }, [_vm._v("18323965465")])])], 1), _vm._v(" "), _c('group', [_c('cell', {
    attrs: {
      "is-link": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-cogs fs24",
    attrs: {
      "aria-hidden": "true"
    },
    slot: "icon"
  }), _vm._v(" "), _c('span', [_vm._v("Setting")])])], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user-descrption"
  }, [_c('h1', [_vm._v("Vue-Alex")]), _vm._v(" "), _c('p', [_vm._v("微信号:x1772463536")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user-link"
  }, [_c('i', {
    staticClass: "fa fa-qrcode",
    attrs: {
      "aria-hidden": "true"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/.11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-26b3b6b2"}!./~/.1.0.61@vux-loader/src/template-loader.js!./~/.11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/me.vue
// module id = 106
// module chunks = 1